import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_LIST_API_ID = 'EMPLOYEE/FETCH_USER_PROGRAMS_INVESTMENT_PLANS_API'

const apiCall = enhancedMakeFetchAction(
  FETCH_LIST_API_ID,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/user-programs/${id}/investment-plans`,
      params
    }),
    method: 'GET'
  })
)

export default apiCall
